import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, Core2Config } from "../../shared";




@Injectable({
    providedIn: 'root'
})
export class EmployeeFileDownloadService extends BaseApiTemplateService<any> {

    // https://api.akaun.cloud/core2/tnt/dm/erp/entity/employee/import-file-hdr/backoffice-ep/download-master-data-template

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/employee/import-file-hdr/backoffice-ep'

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/employee/import-file-hdr/backoffice-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/employee/import-file-hdr/backoffice-ep';
        this.httpClient = http;
    }
    async downloadEmployeeCSV(authorization: string, apiVisa: ApiVisa) {
        const CSV_URL = apiVisa.api_domain_url + this.endpoint_path + '/download-master-data-template';
        const headers = new HttpHeaders({ "authorization": authorization, "tenantCode": apiVisa.tenantCode });
        const fileBlob = await this.httpClient
            .get(CSV_URL, { headers, responseType: 'blob' })
            .toPromise();
        return fileBlob;
    }

}

